import { render } from "./MyActivityDetails.vue?vue&type=template&id=3c6595ff&scoped=true"
import script from "./MyActivityDetails.vue?vue&type=script&lang=js"
export * from "./MyActivityDetails.vue?vue&type=script&lang=js"

import "./MyActivityDetails.vue?vue&type=style&index=0&id=3c6595ff&lang=scss&scoped=true"

import exportComponent from "E:\\code\\项目代码\\温州科技馆\\科技馆公众号\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6595ff"]])

export default __exports__